import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

// Angular 21 made zoneless change detection the default. This application updates
// component state from plain RxJS subscribe callbacks (HTTP responses, service
// subjects) rather than from signals, and zoneless change detection is not notified
// by those, so the view only refreshed on the next DOM event. Zone.js is still loaded
// from polyfills.ts, so opting back in restores the pre-upgrade behaviour.
platformBrowserDynamic()
  .bootstrapModule(AppModule, {
    applicationProviders: [provideZoneChangeDetection()],
  })
  .catch(err => console.error(err));
